import RouteRegister from "@/plugins/router/services/RouteRegister"
import routers from "@/modules/users/routers"

export default {
    install: () => {
        RouteRegister.handle(routers)
    }
}
